
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"38","height":"38","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#FFF","fill-rule":"nonzero"}},[_c('path',{attrs:{"d":"M32.435 5.565A18.876 18.876 0 0019 0 18.876 18.876 0 005.565 5.565 18.876 18.876 0 000 19c0 .644.033 1.29.098 1.93H0V38h27.906v-2.213a19.056 19.056 0 007.16-6.638A18.945 18.945 0 0038 19c0-5.075-1.976-9.846-5.565-13.435zM10.094 35.773H2.227V23.156h7.867v12.617zM10.464 19c0-4.706 3.83-8.535 8.536-8.535 4.706 0 8.535 3.829 8.535 8.535a8.521 8.521 0 01-2.969 6.471v-1.573h-.836a2.972 2.972 0 00-2.875-3.71h-3.71a2.972 2.972 0 00-2.875 3.71h-.836v3.711H12.32v-6.68h-1.635a8.563 8.563 0 01-.22-1.929zm11.876 7.125v1.484h-6.68v-1.484h6.68zm-5.938-2.969c0-.409.333-.742.743-.742h3.71a.743.743 0 010 1.484h-3.71a.743.743 0 01-.743-.742zm9.278 12.617H12.32v-5.937h13.36v5.937zm7.504-7.815a16.837 16.837 0 01-5.278 5.258V27.61h-2.448A10.743 10.743 0 0029.762 19c0-5.934-4.828-10.762-10.762-10.762S8.238 13.066 8.238 19c0 .651.059 1.296.173 1.93H2.337a17.01 17.01 0 01-.11-1.93c0-4.48 1.744-8.693 4.912-11.86A16.664 16.664 0 0119 2.226c4.48 0 8.692 1.744 11.86 4.912A16.664 16.664 0 0135.774 19c0 3.184-.895 6.282-2.59 8.958z"}}),_c('circle',{attrs:{"cx":"32.953","cy":"19","r":"1.113"}}),_c('circle',{attrs:{"cx":"31.84","cy":"13.656","r":"1.113"}}),_c('circle',{attrs:{"cx":"28.426","cy":"8.906","r":"1.113"}}),_c('path',{attrs:{"d":"M3.34 24.641h5.641v2.227H3.34zM3.34 28.352h5.641v2.227H3.34zM3.34 32.063h5.641v2.227H3.34z"}})])])
          )
        }
      }
    